import NavBar from "components/Navigation/NavBar/NavBar";
import DocumentTitle from "components/DocumentTitle/DocumentTitle";
import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import { IUserSession } from "types/user.interface";
import useCheckTutorialActive from "features/onboarding/hooks/useCheckTutorialActive";
import getPageTitleFromPath from "util/pageTitle.util";

type MainLayoutProps = {
  children: ({ searchRef }: { searchRef: any }) => React.ReactNode;
  user: IUserSession;
};

export default function MainLayout({ children, user }: MainLayoutProps) {
  const { pathname } = useLocation();
  const pageTitle = getPageTitleFromPath(pathname);
  const { checkIfOneActive } = useCheckTutorialActive();
  const searchRef: any = useRef(null);

  return (
    <>
      {pageTitle ? <DocumentTitle title={pageTitle} /> : null}
      {!checkIfOneActive() && ( // If any Onboarding is active, hide the navbar
        <NavBar user={user} ref={searchRef} />
      )}
      {children({ searchRef })}
    </>
  );
}
